import {
  CheckCircleOutline,
  EmojiEventsOutlined,
  TrendingUpOutlined,
} from "@mui/icons-material";
import {
  CardHeader,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { findOutEvaluationGenerale } from "./EvaluationExaminationFormResume";

const getObservationStyle = (observation) => {
  const normalizedObservation = String(observation || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  if (normalizedObservation.includes("faible")) {
    return {
      color: "#b42318",
      background: "#fff5f4",
      border: "#fecdca",
      icon: <TrendingUpOutlined sx={{ transform: "rotate(180deg)" }} />,
      message: "Des ameliorations sont necessaires",
    };
  }
  if (normalizedObservation.includes("non satisfaisant")) {
    return {
      color: "#b54708",
      background: "#fffaeb",
      border: "#fedf89",
      icon: <TrendingUpOutlined />,
      message: "En dessous des attentes du poste",
    };
  }
  if (normalizedObservation.includes("satisfaisant")) {
    return {
      color: "#067647",
      background: "#f3fcf7",
      border: "#abefc6",
      icon: <CheckCircleOutline />,
      message: "Conforme aux attentes du poste",
    };
  }
  if (normalizedObservation.includes("superieur")) {
    return {
      color: "#175cd3",
      background: "#f5f8ff",
      border: "#b2ccff",
      icon: <EmojiEventsOutlined />,
      message: "Au-dessus des attentes du poste",
    };
  }
  if (normalizedObservation.includes("exceptionnel")) {
    return {
      color: "#6941c6",
      background: "#faf8ff",
      border: "#d9d6fe",
      icon: <EmojiEventsOutlined />,
      message: "Performance exceptionnelle",
    };
  }
  return {
    color: "#475467",
    background: "#f8fafc",
    border: "#d0d5dd",
    icon: <CheckCircleOutline />,
    message: "Appreciation generale",
  };
};

const RecapEvaluationForm = ({ detailsFicheEvaluation, functionId }) => {
  const noteDetails = detailsFicheEvaluation.filter((detail) =>
    String(detail.TYPE_NAME).toLowerCase().includes("note"),
  );
  const totalScore = noteDetails.reduce(
    (sum, detail) =>
      sum + Number(detail.NOTE ?? detail.NOTE_CA ?? detail.NOTE_MIN ?? 0),
    0,
  );
  const totalMaximum = noteDetails.reduce(
    (sum, detail) => sum + Number(detail.NOTE_MAX || 0),
    0,
  );
  const completion =
    totalMaximum > 0
      ? Math.min(100, Math.max(0, Math.round((totalScore / totalMaximum) * 100)))
      : 0;
  const observation = findOutEvaluationGenerale(totalScore, totalMaximum, functionId);
  const observationStyle = getObservationStyle(observation);
  const categories = Array.from(
    new Set(noteDetails.map((detail) => detail.CATEGORY_NAME)),
  ).map((category) => {
    const categoryDetails = noteDetails.filter(
      (detail) => detail.CATEGORY_NAME === category,
    );
    const score = categoryDetails.reduce(
      (sum, detail) => sum + Number(detail.NOTE ?? detail.NOTE_CA ?? 0),
      0,
    );
    const maximum = categoryDetails.reduce(
      (sum, detail) => sum + Number(detail.NOTE_MAX || 0),
      0,
    );

    return {
      category,
      score,
      maximum,
      completion:
        maximum > 0
          ? Math.min(100, Math.max(0, Math.round((score / maximum) * 100)))
          : 0,
    };
  });

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 1.5,
        overflow: "hidden",
        border: "1px solid #e1e7ef",
        borderTop: "2px solid #00a452",
        borderRadius: 2,
        bgcolor: "#fff",
      }}
    >
      <Grid
        sx={{
          px: { xs: 1.5, sm: 2 },
          py: 1.25,
          bgcolor: "#fbfdfb",
          borderBottom: "1px solid #e8edf3",
        }}
      >
        <CardHeader
          title="Section C-1 : Le niveau du rendement du Consultant est la somme des evaluations"
          titleTypographyProps={{
            variant: "subtitle1",
            sx: { color: "#175cd3", fontWeight: 600 },
          }}
          subheaderTypographyProps={{
            variant: "caption",
            sx: { color: "#718096" },
          }}
          sx={{ p: 0 }}
        />
      </Grid>

      <Grid sx={{ p: { xs: 1.5, sm: 2.5 } }}>
        <TableContainer
          sx={{
            border: "1px solid #e1e7ef",
            borderRadius: 1.5,
            overflowX: "auto",
          }}
        >
          <Table size="small" aria-label="Recapitulatif des notes">
            <TableHead>
              <TableRow sx={{ bgcolor: "#f8fafc" }}>
                <TableCell sx={{ fontWeight: 700, minWidth: 220 }}>
                  Section
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, minWidth: 120 }}>
                  Somme des notes donnees
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, minWidth: 135 }}>
                  Somme des notes maximum
                </TableCell>
               {/*  <TableCell align="center" sx={{ fontWeight: 700, minWidth: 145 }}>
                  Taux de realisation
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map(({ category, score, maximum, completion }) => (
                <TableRow key={category} hover>
                  <TableCell>{category}</TableCell>
                  <TableCell align="center">
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        display: "inline-block",
                        px: 1.25,
                        py: 0.35,
                        borderRadius: 1,
                        bgcolor: "#f0f4f8",
                        fontWeight: 600,
                      }}
                    >
                      {score}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ color: "text.secondary" }}>
                    Sur {maximum} points
                  </TableCell>
                  {/* <TableCell>
                    <Grid
                      display="flex"
                      alignItems="center"
                      gap={1}
                      minWidth={105}
                    >
                      <LinearProgress
                        variant="determinate"
                        value={completion}
                        sx={{
                          flex: 1,
                          height: 6,
                          borderRadius: 5,
                          bgcolor: "#e7edf2",
                          "& .MuiLinearProgress-bar": {
                            borderRadius: 5,
                            bgcolor: "#00a452",
                          },
                        }}
                      />
                      <Typography variant="caption" sx={{ minWidth: 28 }}>
                        {completion}%
                      </Typography>
                    </Grid>
                  </TableCell> */}
                </TableRow>
              ))}
              <TableRow sx={{ bgcolor: "#fbfcfd" }}>
                <TableCell sx={{ fontWeight: 600 }}>
                  Total des criteres d'evaluation du Consultant
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700 }}>
                  {totalScore}
                </TableCell>
                <TableCell align="center">Sur {totalMaximum} points</TableCell>
               {/*  <TableCell align="center" sx={{ fontWeight: 700 }}>
                  {completion}%
                </TableCell> */}
              </TableRow>
              <TableRow sx={{ bgcolor: "#f5f9ff" }}>
                <TableCell sx={{ fontWeight: 600 }}>
                  L'appreciation generale du Consultant
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: 700, color: "#175cd3" }}>
                  {totalScore}
                </TableCell>
                <TableCell align="center">Sur {totalMaximum} points</TableCell>
               {/*  <TableCell align="center" sx={{ fontWeight: 700, color: "#175cd3" }}>
                  {completion}%
                </TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Grid sx={{ mt: 2.5, pt: 1.5, borderTop: "1px solid #e8edf3" }}>
          <CardHeader
            title="Section C-2 : Classification finale"
            titleTypographyProps={{
              variant: "subtitle1",
              sx: { color: "#175cd3", fontWeight: 600 },
            }}
            subheaderTypographyProps={{
              variant: "caption",
              sx: { color: "#718096" },
            }}
            sx={{ p: 0, mb: 1.5 }}
          />

          <Grid
            container
            spacing={1.5}
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  minHeight: 104,
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  border: "1px solid #e1e7ef",
                  borderLeft: "2px solid #00a452",
                  borderRadius: 1.5,
                  bgcolor: "#fbfdfb",
                }}
              >
                <Grid>
                  <Typography
                    variant="caption"
                    sx={{ color: "#718096", fontWeight: 600, textTransform: "uppercase" }}
                  >
                    Note globale
                  </Typography>
                  <Grid display="flex" alignItems="baseline" gap={0.5}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: "#172033" }}>
                      {totalScore}
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                      / {totalMaximum}
                    </Typography>
                  </Grid>
                  {/* <Typography variant="caption" sx={{ color: "#067647" }}>
                    Resultat selon le bareme officiel
                  </Typography> */}
                </Grid>
                <Grid sx={{ position: "relative", display: "inline-flex", flexShrink: 0 }}>
                  <CircularProgress
                    variant="determinate"
                    value={completion}
                    size={42}
                    thickness={4}
                    sx={{
                      color: "#2563eb",
                      "& .MuiCircularProgress-circle": { strokeLinecap: "round" },
                      "&::before": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        border: "3px solid #e7edf2",
                        borderRadius: "50%",
                      },
                    }}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "grid",
                      placeItems: "center",
                      fontSize: "0.6rem",
                      fontWeight: 600,
                    }}
                  >
                    {completion}%
                  </Typography>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Paper
                elevation={0}
                sx={{
                  height: "100%",
                  minHeight: 104,
                  p: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  border: `1px solid ${observationStyle.border}`,
                  borderLeft: "2px solid #00a452",
                  borderRadius: 1.5,
                  bgcolor: observationStyle.background,
                }}
              >
                <Grid minWidth={0}>
                  <Typography
                    variant="caption"
                    sx={{ color: observationStyle.color, fontWeight: 600, textTransform: "uppercase" }}
                  >
                    Observation
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      color: observationStyle.color,
                      fontWeight: 700,
                      lineHeight: 1.25,
                      overflowWrap: "anywhere",
                    }}
                  >
                    {observation || "Non evalue"}
                  </Typography>
                  {/* <Typography variant="caption" sx={{ color: observationStyle.color }}>
                    {observationStyle.message}
                  </Typography> */}
                </Grid>
                <Grid
                  sx={{
                    display: "grid",
                    placeItems: "center",
                    width: 40,
                    height: 40,
                    flexShrink: 0,
                    borderRadius: 1.5,
                    color: observationStyle.color,
                    bgcolor: `${observationStyle.color}14`,
                  }}
                >
                  {observationStyle.icon}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default RecapEvaluationForm;